<template>
    <div class="opera-moreFunction">
      	<div class="hdfix" >
        <mt-header>
            <div slot="left">
            <router-link to="/opera/" v-if="!status">
                <i class="mintui mintui-back"></i>
            </router-link>
            <mt-button class='left' v-bind:class="{ active: status }" @click='goBack'>{{status ?$t('cancel'):$t('myApp')}}</mt-button>
            <span class="tip" v-if="status">（{{$t('moreFunction_tip')}}）</span>
            </div>
            <mt-button slot="right" class='right' @click='setList'>{{status ?$t('complete'):$t('edit')}}
            </mt-button>
        </mt-header>
      	</div>
        <my-list :isEdit='status' ></my-list>
    </div>
</template>
<script>
import myList from "../operaCommon/myList";
import _ from "lodash";

export default {
  data() {
    return {
      status: this.$route.query.status || false
    };
  },
  methods: {
    goBack() {
      if (this.status) {
        this.$store.commit(
          "setMyList",
          JSON.parse(localStorage.getItem("operaMyList"))
        );
        this.status = false;
      }
    },
    setList() {
      console.log(this.status);
      if (this.status) {
        var postOptions = [];
        var myListCopy = _.cloneDeep(this.$store.state.operaMyList.operaMyList);
        _.forEach(this.$store.state.operaMyList.operaMyList, value => {
          postOptions.push({ functionId: value.id });
        });

        this.$http
          .post("/mobilepmsapi/sys/updateMyFunciton", postOptions)
          .then(res => {
            if (res.data.result == 0) {
              localStorage.setItem("operaMyList", JSON.stringify(myListCopy));
            }
          });
      }

      this.status = !this.status;
    }
  },
  components: {
    myList
  }
};
</script>
<style lang='less'>
.opera-moreFunction {
   .hdfix {
    height: 1.066667rem;
    position: relative;
    z-index: 10;
   }
  .mint-header {
    border-bottom: 1px solid #eee;
    padding: 0;
    line-height: 1.066667rem;
    background: #393c41;
    position: fixed;
    top:0;left:0;
    width:100%;
    height:1.066667rem ;
    color:#fff;
  }
  .nav .item {
    border:none;
  }
  .nav .active {
    border: 1px solid #eee;
    border-top: none;
    border-right: none;
    padding:0.32rem !important;
  }
  .nav .last.active {
    border-right: 1px solid #eee;
  }
  .nav .normalFn h1 {
    background: #f6f8f9;
    line-height: 0.4rem;
    border-bottom: 1px solid #eee;
  }
  .router-link-active {
    float: left;
  }
  .right {
    padding: 0 0.5rem !important;
    .mint-button-text {
      font-size: 12px;
    }
  }
  .left {
    .mint-button-text {
      font-size: 0.4rem;
    }

  }
   .tip{font-size:0.32rem;color:#ccc;}
  .active {
      padding: 0 0 0 0.5rem !important;
    .mint-button-text {
      font-size: 12px;

    }
  }
  .mintui-back {
    font-size: 0.7rem;
    line-height: 41px;
    // height: 1.0667rem;
    padding: 0.2rem;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// moreFunction.vue?353f1a9d